<div style="max-width:800px;">
    <!-- <div style="height:40px; display:flex; flex-direction:row; align-items: center; justify-content: space-between;">
  
      <div style="">
        Current Status: <strong>
          <span *ngIf="membership.status == 'Trial'">Pro:Trial</span>
          <span *ngIf="membership.status == 'Active'">Pro</span>
          <span *ngIf="membership.status == 'Free'">Free</span>
        </strong>  
      </div>
      <div style="">
        Monthly
        <kendo-switch [(ngModel)]="this.product_yearly" [size]="'small'"></kendo-switch>
        Yearly
      </div>
  
      <div style="" *ngIf="!this.promotion">
  
  
  
        <a class="k-button k-outline k-button-md k-rounded-md k-button-outline-base k-button-outline" target="_blank" kendoButton fillMode="outline" [href]="portal.url"
          title="Stripe customer billing portal"
          [class.disabled]="!portal.url"
          *ngIf="{ url: paymentService.portal$ | async} as portal" >
          <fa-icon icon="address-card"></fa-icon>&nbsp;
          Customer Billing Portal
        </a>
        &nbsp;
        <button kendoButton fillMode="outline"
          (click)="openUpdateHandler()" style="min-width:150px;" *ngIf="membership.status == 'Active'">
          <fa-icon icon="credit-card"></fa-icon>&nbsp;
          Update Card Details
        </button>
      </div>
    
    </div> -->
  
    <!-- <div class="example-box" *ngIf="error">
      {{error}}  <button (click)="retry()">Retry</button>
    </div> -->
  
    <div class="container">
  
      <kendo-card style="">
        <kendo-card-header>
          <h1 style="font-weight:bold; " kendoCardTitle>Quick Start</h1>
          <p kendoCardSubtitle>Free</p>
        </kendo-card-header>
        <kendo-card-body>

            <p>
                A 15-minute consultation to discuss your needs.
            </p>

            <ul style="flex-grow: 1;">
                <li>Free 15-Min Intro Call</li>
                <li>Understand the scope of your project or issue</li>
                <li>Get a tailored action plan with our Power Platform expertise</li>
            </ul>

        </kendo-card-body>
        <!-- <hr kendoCardSeparator> -->
        <kendo-card-actions>
          <a class="k-button k-primary k-button-solid-primary k-button-solid k-button-md k-rounded-md" href="https://outlook.office.com/owa/calendar/FlowStudioSolutions@flowstudio.app/bookings/?ismsaljsauthenabled" target="_blank">Book Your Free Intro Call</a>
          <!-- <a href="https://learn.flowstudio.app" target="learn" (click)="$event.stopPropagation()"
            class="k-button k-primary k-outline k-button-md k-rounded-md button-logo-1" style="flex-basis: 50%;">
            <fa-icon icon="user-graduate" title="Learn"></fa-icon>
            Learn More
          </a> -->
        </kendo-card-actions>
      </kendo-card>
      <kendo-card>
        <kendo-card-header>
            <h1 style="font-weight:bold;" kendoCardTitle>Hourly Consulting</h1>
            <p kendoCardSubtitle>US$150/hour</p>
        </kendo-card-header>
        <kendo-card-body>

            <p>
                Flexible support for troubleshooting and customizations across Power Automate, Power BI, Power Apps, and SharePoint.
            </p>
            <span style="font-weight:bold;">
                Hourly Packages (Save Up to 20%):
            </span>

            <ul style="flex-grow: 1;">
                <li>5 hours: US$675 (10% off, save $75)</li>                
                <li>10 hours: US$1,275 (15% off, save $225)</li>                
                <li>20 hours: US$2,400 (20% off, save $600)</li>
            </ul>
            
        </kendo-card-body>
        <!-- <hr kendoCardSeparator> -->
        <kendo-card-actions>
            <!-- <a class="k-button k-primary k-outline k-button-md k-rounded-md" href="https://outlook.office.com/owa/calendar/FlowStudioSolutions@flowstudio.app/bookings/?ismsaljsauthenabled" target="_blank">Book Now</a> -->
        </kendo-card-actions>
      </kendo-card>
      <kendo-card>
        <kendo-card-header>
            <h1 style="font-weight:bold;" kendoCardTitle>Managed Service</h1>
            <p kendoCardSubtitle>Starting at US$500/month</p>
        </kendo-card-header>
        <kendo-card-body>

            <p>
                Ongoing service ensuring your flows, Power Apps, Power BI dashboards and SharePoint automation keep running.
            </p>

            <ul style="flex-grow: 1;">
                <li><strong>Essential</strong>: US$500/month - up to 4 hours, email support, 48h SLA</li>
                <li><strong>Growth</strong>: US$1000/month - up to 10 hours, 24h SLA</li>
                <li style="padding-bottom:20px;"><strong>Proactive</strong>: US$2000/month - up to 20 hours, 24h SLA + recurring check-ins</li>
                <li class="👍">Maintain and optimize solutions, even if developed by others</li>
            </ul>

            <p>Need more? Let's customize a plan for your enterprise.</p>

        </kendo-card-body>
        <!-- <hr kendoCardSeparator> -->
        <kendo-card-actions>
            <!-- <a class="k-button k-primary k-outline k-button-md k-rounded-md" href="https://outlook.office.com/owa/calendar/FlowStudioSolutions@flowstudio.app/bookings/?ismsaljsauthenabled" target="_blank">Call Now</a> -->
        </kendo-card-actions>
      </kendo-card>
      </div>
  
  </div>
  
